module.exports = __webpack_public_path__ + "img/image7.7c178b1a.svg";